import type { V2Finding } from '../domain/finding';
import type { FindingState } from './findingStore';
import type { InspectionState } from './inspectionStore';

// THE one definition of 「问题记录 / Findings」 as a number (device walkthrough 2026-10-27, B2: the overview
// said 1, its area cards added up to 11 and Home said 11 — three counts, three sources). A finding of an
// inspection is
//   · a checklist row whose result is 缺陷 / Defect (CA-15: the row's defect IS the finding), plus
//   · an other finding the inspector saved (confirmed; a draft is not a finding yet, a rejected one no more),
//     voluntary observations excluded (OD-13: courtesy entries, never findings of the inspection)
// in the ENABLED areas only. It is the number the report summary prints (src/report/assembly.ts), and the
// overview, its area cards, Home, the Inspections list and the Findings screen all read it from here.
export function isCountedOtherFinding(finding: V2Finding): boolean {
  return finding.status === 'confirmed' && !finding.voluntaryObservation;
}

export function areaIssueCount(state: Pick<InspectionState, 'items'>, findings: Pick<FindingState, 'findings'>, areaId: string): number {
  const rows = state.items.filter((i) => i.areaId === areaId && i.status === 'issueFound').length;
  const others = findings.findings.filter((f) => f.areaId === areaId && isCountedOtherFinding(f)).length;
  return rows + others;
}

export function inspectionIssueCount(state: InspectionState, findings: Pick<FindingState, 'findings'>, inspectionId: string): number {
  const inspection = state.inspections.find((i) => i.id === inspectionId) ?? null;
  // OD-12: after the final report deleted the working data only the frozen counts are left — the defect
  // rows and the confirmed other findings the report was built from.
  if (inspection?.purge) return inspection.purge.progress.issues + inspection.purge.findingCount;
  return state.areas.filter((a) => a.inspectionId === inspectionId && a.enabled).reduce((sum, area) => sum + areaIssueCount(state, findings, area.id), 0);
}
